module.exports = __webpack_public_path__ + "static/media/Qualification settings.bd886427.svg";